import { useTranslate } from "src/i18n";

export const useServicesBlockTranslate = () => {
  const { t } = useTranslate();

  const title = t("outsourcing.services_block.title", "Наши услуги");

  const description = t(
    "outsourcing.services_block.description",
    "Какие услуги мы можем предложить, для вашего бизнеса",
  );

  const servicesData = [
    {
      title: t(
        "outsourcing.services_block.services_data.0.title",
        "Разработка интернет-магазинов",
      ),
      description: t(
        "outsourcing.services_block.services_data.0.description",
        "Мы создаем современные и функциональные интернет-магазины, которые не только привлекают клиентов, но и обеспечивают высокую конверсию. От дизайна до интеграции с платежными системами — мы берем на себя все этапы разработки.",
      ),
    },
    {
      title: t(
        "outsourcing.services_block.services_data.1.title",
        "Интеграция с платформами",
      ),
      description: t(
        "outsourcing.services_block.services_data.1.description",
        "Мы обеспечиваем seamless-интеграцию вашего магазина с популярными платформами, такими как WooCommerce, InSales и другими. Это позволяет вам использовать все преимущества этих решений без лишних затрат времени и ресурсов.",
      ),
    },
    {
      title: t(
        "outsourcing.services_block.services_data.2.title",
        "Оптимизация и поддержка",
      ),
      description: t(
        "outsourcing.services_block.services_data.2.description",
        "Мы не только создаем магазины, но и помогаем их оптимизировать для повышения производительности и удобства пользователей. Также предоставляем постоянную техническую поддержку для решения любых вопросов.",
      ),
    },
    {
      title: t(
        "outsourcing.services_block.services_data.3.title",
        "Персонализация и маркетинг",
      ),
      description: t(
        "outsourcing.services_block.services_data.3.description",
        "Мы внедряем персонализированные решения для улучшения взаимодействия с клиентами. Наши маркетинговые инструменты помогают увеличить продажи и удержать аудиторию.",
      ),
    },
  ];

  return { title, description, servicesData };
};
